import React, { Suspense } from 'react';

/**
 * Renders nothing until `open` is first true, then stays mounted so close
 * transitions and internal state behave like an always-mounted dialog.
 */
class MountWhenOpened extends React.Component {
  constructor(props) {
    super(props);
    this.state = { opened: Boolean(props.open) };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.open && !state.opened) {
      return { opened: true };
    }
    return null;
  }

  render() {
    if (!this.state.opened) return null;
    return <Suspense fallback={null}>{this.props.children}</Suspense>;
  }
}

export default MountWhenOpened;
